import Chat from '@assets/icons/chat.svg'
import { Icon } from './Icon'

export const ChatIcon = Icon(Chat)
